import { render, staticRenderFns } from "./InsertTask.vue?vue&type=template&id=bad3c52c"
import script from "./InsertTask.vue?vue&type=script&lang=js"
export * from "./InsertTask.vue?vue&type=script&lang=js"
import style0 from "./InsertTask.vue?vue&type=style&index=0&id=bad3c52c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports